var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirl5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F4DA92"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_1442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_1442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1012.27 1197.33C1009.23 1199.5 1005.77 1201.66 1002.73 1203.83C999.265 1206 996.232 1208.16 992.765 1209.9C989.732 1211.63 987.132 1213.36 984.099 1215.1C983.665 1215.53 983.232 1215.53 982.799 1215.96C972.832 1222.03 962.432 1227.66 952.032 1232.86C948.999 1234.6 945.532 1236.33 942.499 1237.63C942.499 1237.63 942.065 1238.06 941.632 1238.06C938.165 1239.8 934.699 1241.53 931.232 1243.26C924.299 1246.73 916.932 1249.76 909.999 1252.8C906.532 1254.53 902.632 1255.83 899.165 1257.13C895.699 1258.43 891.799 1260.16 888.332 1261.46C884.865 1262.76 880.965 1264.5 877.499 1265.8C877.499 1265.8 877.499 1265.8 877.065 1265.8C873.599 1267.1 869.699 1268.4 866.232 1269.7C858.432 1272.3 850.199 1274.9 842.399 1277.5C839.799 1278.36 836.765 1279.23 834.165 1280.1C825.932 1282.7 817.699 1284.86 809.465 1286.6C806.432 1287.46 803.399 1287.9 799.932 1288.76C792.132 1290.5 783.899 1292.23 776.099 1293.96C774.365 1294.4 773.065 1294.4 771.332 1294.83C768.732 1295.26 765.699 1295.7 763.099 1296.13C759.199 1296.56 755.732 1297.43 751.832 1297.86C750.099 1298.3 748.365 1298.3 746.632 1298.73C744.465 1299.16 741.865 1299.6 739.265 1299.6C732.332 1300.46 724.965 1301.33 718.032 1302.2C715.865 1302.63 713.265 1302.63 711.099 1303.06H710.665C707.632 1303.5 704.599 1303.5 701.565 1303.93C698.532 1304.36 695.499 1304.36 692.465 1304.36C690.732 1304.36 688.565 1304.8 686.832 1304.8C683.365 1304.8 680.332 1305.23 677.299 1305.23C672.965 1305.23 669.065 1305.66 664.732 1305.66C660.399 1305.66 656.499 1305.66 652.165 1305.66C649.132 1305.66 646.099 1305.66 643.065 1305.66C460.632 1303.06 295.965 1225.5 178.965 1102.43C178.965 1102.43 178.965 1102 178.532 1102C191.965 1075.56 241.799 1027.9 293.799 988.465C359.665 938.631 452.832 907.865 452.832 907.865C452.832 907.865 513.932 897.898 740.565 945.131C913.465 981.531 987.132 1129.3 1012.27 1197.33Z",
    fill: "#C99589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.665 1065.16C779.565 1109.8 720.632 1136.23 621.399 1096.36C499.632 1046.96 452.832 907.865 452.832 907.865C446.332 808.198 431.165 722.831 431.165 722.831C571.999 710.698 738.399 875.365 738.399 875.365L757.465 956.831C759.199 963.764 762.665 969.831 767.865 974.165C776.965 989.764 794.732 1036.56 788.665 1065.16Z",
    fill: "#C99589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.865 974.598C685.099 970.265 623.999 958.131 558.565 840.698C614.032 889.665 679.465 908.298 748.365 916.965L757.465 956.831C759.199 964.198 762.665 970.265 767.865 974.598Z",
    fill: "#A56663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.032 452.431C946.832 488.831 950.732 518.298 929.499 615.365C908.265 712.431 948.999 809.498 846.732 898.331C777.832 958.131 657.365 969.398 561.165 903.965C528.665 881.865 498.765 851.098 474.499 810.798C455.432 779.165 433.332 749.265 408.632 721.965C374.399 684.698 333.232 609.731 353.599 477.131C386.532 261.331 600.165 236.631 726.265 260.465C852.365 284.298 917.799 356.231 939.032 452.431Z",
    fill: "#C99589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.332 621.865C524.332 621.865 510.899 556.865 447.632 564.665C393.032 571.598 373.965 702.465 497.899 738.865",
    fill: "#C99589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.999 679.498C493.999 679.498 478.399 669.531 480.132 652.198C482.732 631.831 480.132 619.265 470.599 615.365C446.765 605.398 441.999 633.131 442.865 636.598",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.632 721.531C824.632 721.531 841.099 722.398 856.699 703.765C865.365 693.365 872.732 680.365 867.965 676.465C863.199 672.131 784.765 684.265 779.565 694.665C774.365 705.065 804.699 721.531 824.632 721.531Z",
    fill: "#A56663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.632 575.931C837.632 575.931 838.499 617.098 864.932 663.031C876.632 683.398 858.865 716.765 820.299 722.398",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.93 1465.49H63.462C63.462 1465.49 69.9619 1264.42 135.829 1120.99C185.662 1012.65 303.095 952.421 390.629 921.221C415.329 912.554 437.862 906.054 455.195 901.287C455.195 903.454 455.629 905.187 455.629 907.354C455.629 907.354 502.429 1046.45 624.195 1095.85C723.429 1136.15 782.362 1109.29 791.462 1064.65C797.095 1036.05 779.329 989.254 770.229 974.087C765.029 969.754 761.562 963.254 759.829 956.754L756.362 942.454C764.595 940.721 772.395 938.554 780.195 935.954C782.795 935.087 784.962 934.221 787.562 933.354C843.462 948.087 927.528 983.187 1026.76 1066.39C1139 1159.99 1158.93 1465.49 1158.93 1465.49Z",
    fill: "#BEE3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.495 1140.92C436.995 1073.75 378.928 953.721 390.195 921.221C390.195 921.221 390.195 920.787 390.628 920.354C398.428 904.321 410.995 891.321 426.595 882.221C435.261 877.021 444.795 872.254 452.595 869.654C453.028 875.72 454.761 894.787 455.195 901.287C455.195 903.454 455.628 905.187 455.628 907.354C455.628 907.354 483.361 1010.92 605.128 1060.32C704.361 1100.62 765.895 1074.19 772.395 1029.12C779.761 979.287 751.595 943.32 751.595 943.32C759.828 941.587 772.828 938.554 780.628 935.954C799.695 958.921 819.195 981.887 826.561 1042.55C836.961 1129.65 741.195 1210.69 586.495 1140.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.962 1465.49L258.462 1304.72",
    stroke: "#544D4D",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.56 1250.12C1034.56 1250.12 1021.56 1281.75 1025.46 1313.39C1029.36 1345.02 1040.63 1391.39 1024.6 1465.49",
    stroke: "#544D4D",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.943 619.439C673.543 619.006 665.743 610.339 666.61 599.939L667.043 587.806C667.476 577.406 676.143 569.606 686.543 570.472C696.943 570.906 704.743 579.572 703.876 589.972L703.443 602.106C703.01 612.072 694.343 619.872 683.943 619.439Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.376 625.939C856.843 625.505 849.476 617.272 849.909 607.739L850.343 596.472C850.776 586.939 859.009 579.572 868.543 580.005C878.076 580.439 885.443 588.672 885.009 598.205L884.576 609.472C884.143 619.005 875.909 626.372 866.376 625.939Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.977 594.305C725.977 594.305 714.71 578.272 695.21 575.239C679.177 572.639 661.41 580.439 658.81 589.539",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.81 598.206C853.81 598.206 853.81 584.339 873.743 584.339C890.21 584.339 897.143 599.506 897.143 599.506",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.743 524.539C752.843 527.572 761.943 519.339 760.209 509.372C759.343 504.172 757.176 498.972 752.843 495.072C739.843 483.372 686.109 472.972 653.609 488.139C625.009 502.005 702.143 510.672 743.743 524.539Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.308 531.472C865.942 534.072 858.141 526.272 859.441 517.172C859.875 512.406 861.608 507.639 865.075 504.172C875.475 493.772 911.008 485.539 933.542 501.572C953.042 515.006 907.108 518.906 873.308 531.472Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.925 774.866C805.693 779.808 800.302 769.924 782.78 778.46C770.199 784.301 763.46 786.098 748.184 777.112C738.3 770.822 726.169 779.808 714.488 762.735",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.422 390.617C920.122 324.75 949.155 481.617 942.655 450.85C940.489 441.317 937.889 432.217 934.855 423.117C911.889 404.917 887.622 393.217 850.789 388.017C751.555 374.584 673.122 383.684 589.489 401.884C537.055 413.151 547.889 594.284 527.522 618.117C524.055 605.984 507.155 556.584 451.689 563.517C399.256 570.017 379.322 691.35 487.656 732.95C486.789 756.784 464.689 800.984 446.922 810.95C446.922 810.95 443.889 779.317 409.222 737.717C374.556 696.117 305.222 588.217 352.022 430.484C398.822 272.75 610.722 190.417 807.889 270.584C841.689 284.451 869.422 303.95 891.522 324.317C943.522 371.984 929.655 303.95 921.422 374.15C918.389 396.684 921.422 373.717 908.422 390.617Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.656 372.85C864.656 372.85 745.056 571.75 507.156 511.084C507.156 511.084 460.789 394.517 561.756 349.884C663.156 305.684 840.389 333.85 864.656 372.85Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.056 384.55C823.056 384.55 870.723 393.65 904.089 429.184C935.289 462.117 941.789 318.684 948.723 350.317C948.723 350.317 966.489 393.65 889.356 347.717C812.223 301.35 823.056 384.55 823.056 384.55Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.589 625.051C351.589 625.051 298.722 591.251 221.589 625.051C151.822 655.817 188.222 743.784 232.856 737.284C232.856 737.284 148.789 769.784 179.989 839.117C205.122 895.017 281.389 862.517 281.389 862.517C281.389 862.517 245.422 920.151 298.289 946.151C352.022 972.584 379.322 898.051 379.322 898.051C379.322 898.051 391.889 959.151 446.922 949.617C514.956 937.917 480.289 856.884 480.289 856.884C480.289 856.884 517.122 881.151 533.589 839.117C552.656 791.017 468.589 752.884 468.589 752.884C468.589 752.884 380.189 651.484 376.289 611.617C371.956 571.317 351.589 625.051 351.589 625.051Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.955 822.217C995.955 822.217 1057.06 863.817 1021.09 915.817C978.189 978.217 906.255 910.183 906.255 910.183C919.255 952.217 872.455 1021.55 808.755 966.95C796.622 956.55 787.089 945.717 779.722 935.317C806.155 926.65 830.422 913.65 850.355 896.317C907.555 846.917 920.122 794.484 923.589 741.184C925.322 717.35 924.889 693.517 926.189 669.25C927.055 652.784 928.355 636.75 931.389 620.284C954.789 603.384 998.989 602.517 1010.69 628.084C1038.42 689.184 986.855 714.317 983.822 715.617C987.289 714.75 1068.76 697.85 1069.19 764.15C1070.06 833.917 995.955 822.217 995.955 822.217Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.089 424.85C943.089 424.85 1037.56 491.15 1017.19 361.15C1001.59 261.917 926.622 203.85 808.322 238.95C808.322 238.95 606.822 164.417 446.922 256.717C311.722 334.717 303.922 531.017 352.022 625.051C352.022 625.051 358.089 436.551 490.689 391.917C622.855 347.284 703.455 312.617 822.622 352.917C941.789 393.217 943.089 424.85 943.089 424.85Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.856 258.017C843.856 258.017 830.856 177.85 761.523 167.45C691.756 157.05 722.523 239.384 722.523 239.384C722.523 239.384 820.023 276.65 843.856 258.017Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.488 225.951C745.488 225.951 709.088 175.684 639.755 185.217C570.422 194.751 614.188 251.517 614.188 251.517C614.188 251.517 760.655 290.951 745.488 225.951Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.856 390.617C843.856 390.617 893.689 412.717 924.456 457.35C955.222 501.984 1010.69 491.584 1018.49 408.817C1026.72 326.484 865.956 303.084 843.856 390.617Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M865.083 677.253C865.083 677.253 870.283 706.72 904.516 721.453C913.183 724.92 922.283 719.286 922.283 709.753C921.85 709.753 867.25 680.72 865.083 677.253Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M782.75 606.187C782.75 606.187 810.483 578.453 824.35 575.42L787.516 584.086L782.75 606.187Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M597.717 677.254C597.717 677.254 613.75 713.653 661.85 722.32C709.95 731.42 753.717 696.754 774.083 638.687C774.083 638.687 757.617 692.42 691.75 702.387C626.317 713.22 597.717 677.254 597.717 677.254Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M675.283 482.687C614.183 482.687 564.35 533.82 563.916 596.22C563.916 625.687 574.75 652.554 592.516 672.054L749.816 513.02C730.316 493.954 704.316 482.687 675.283 482.687Z",
    fill: "#DBC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M749.817 513.02L592.517 672.054C612.45 694.154 640.617 707.587 671.817 707.587C732.05 707.587 781.45 657.754 783.183 595.787C784.05 563.287 771.05 533.82 749.817 513.02Z",
    fill: "#C4ADD8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M928.783 482.687C882.416 482.687 843.416 533.82 841.683 596.22C840.816 621.354 846.45 644.32 855.983 662.954L993.35 526.887C979.05 500.02 955.65 482.687 928.783 482.687Z",
    fill: "#DBC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M993.349 526.453L855.983 662.52C870.283 689.82 893.683 707.586 920.983 707.586C966.483 707.586 1005.48 657.753 1008.08 595.786C1008.95 570.22 1003.32 545.953 993.349 526.453Z",
    fill: "#C4ADD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.183 596.22C781.883 658.187 732.049 708.02 671.816 708.02C611.583 708.02 563.483 658.187 563.483 596.22C563.916 533.82 613.749 482.687 674.849 482.687C735.949 482.687 784.916 533.82 783.183 596.22Z",
    stroke: "black",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.08 596.22C1005.48 658.187 966.483 708.02 920.983 708.02C875.483 708.02 839.95 658.187 841.683 596.22C843.416 533.82 882.416 482.687 928.783 482.687C975.15 482.687 1010.68 533.82 1008.08 596.22Z",
    stroke: "black",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.783 584.086H503.25",
    stroke: "black",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.616 584.086C783.616 584.086 835.183 564.153 841.683 584.086",
    stroke: "black",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl5);
export default __webpack_public_path__ + "static/media/Girl_5.7e500913b7483527bc6263bdff90582d.svg";
export { ForwardRef as ReactComponent };